import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getStoredData } from '../../JsonFiles/fetchData';
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import HomeBlog from '../../components/HomeBlog/HomeBlog';
import SliderBlog from '../../components/SliderBlog/SliderBlog';

const Blog = () => {
  const data = getStoredData()?.["12"] ?? {};
  const [Blog, setBlog] = useState([]);
  const [News, setNews] = useState([]);

  useEffect(() => {
    // Fetch products
    axios.get('https://shahbad-enterprises-backend.vercel.app/blog')
      .then(response => setBlog(response.data))
      .catch(error => console.error('Error fetching blog:', error));

      axios.get('https://shahbad-enterprises-backend.vercel.app/news')
      .then(response => setNews(response.data))
      .catch(error => console.error('Error fetching news:', error));
  }, []);

  return (
    <div>
       <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <SliderBlog data={Blog}/>
      <HomeBlog
        title={data.HomeBlogTitle}
        link={data.HomeBlogLink}
        text={data.HomeBlogText}
        blogs={News}
      />
    </div>
  )
}

export default Blog